import { Marker, Popup } from 'react-leaflet'
import L from 'leaflet'
import { renderCoordinate } from '../../utils/utils'
import { useMap } from 'react-leaflet'
import { useEffect, useState } from 'react'
import { useRef } from 'react'
import { handleCopyToClipboard } from '../../utils/utils'
import hylkyservices from '../../services/hylkykortti.js'
import ReactDOMServer from 'react-dom/server'
import { useNavigate } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { scrollToElement } from '../../utils/utils'
import he from 'he'

const WreckMarker = ({ wreck, id, centerAndZoom }) => {
  const [wreckId, setWreckId] = useState(null)
  const map = useMap()

  const navigate = useNavigate()

  const markerRef = useRef(null)
  const popupRef = useRef(null)

  const getPopupContent = (extraInfo) => {
    return ReactDOMServer.renderToStaticMarkup(
      <div className="map-item-info">
        <Button
          className="p-0 navigateToHylkykortti"
          size="sm"
          variant="link"
          data-coords={wreck.id}
          dangerouslySetInnerHTML={{ __html: wreck.title.rendered }}
        ></Button>
        <div className="mb-1">
          {renderCoordinate(Number(wreck.meta.gpsLatitude[0]), true)}
          <br />
          {renderCoordinate(Number(wreck.meta.gpsLongitude[0]), false)}
          <button
            className="mx-1 copyToClipboard bi bi-copy"
            data-coords={`${wreck.meta.gpsLatitude[0]}, ${wreck.meta.gpsLongitude[0]}`}
          />
        </div>
        {extraInfo
          ? Object.entries(extraInfo)
              .filter(([_, value]) => value)
              .map(([key, value], index) => (
                <div key={index}>
                  <strong>{key.charAt(0).toUpperCase() + key.slice(1).replace('_', ' ')}: </strong>
                  {value}
                  <br />
                </div>
              ))
          : 'Loading...'}
      </div>,
    )
  }

  useEffect(() => {
    markerRef.current.bindPopup(getPopupContent(markerRef.current.extra))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const handler = async (e) => {
      if (e.target.classList.contains('copyToClipboard')) {
        const coords = e.target.getAttribute('data-coords')
        await handleCopyToClipboard(coords)
      }
      if (e.target.classList.contains('navigateToHylkykortti')) {
        const wreckId = e.target.getAttribute('data-coords')
        navigate(`/hylkykortti/${wreckId}`)

        scrollToElement(`hylkykortti-${id}`)
      }
    }
    document.addEventListener('click', handler)
    return () => document.removeEventListener('click', handler)
  }, [])

  useEffect(() => {
    if (centerAndZoom) {
      map.setView([Number(wreck.meta.gpsLatitude[0]), Number(wreck.meta.gpsLongitude[0])], 14)
    }
    if (wreck && !wreckId) {
      setWreckId(wreck.id)
    }
  }, [centerAndZoom, wreck, map, wreckId])

  useEffect(() => {
    if (centerAndZoom && markerRef.current) {
      map.openPopup(popupRef.current, markerRef.current.getLatLng())
    }
  }, [markerRef.current, centerAndZoom])

  const fetchPopupExtraContent = async (id) => {
    const fetchData = async () => {
      const response = await hylkyservices.getPage(id)

      const extraInfo = {
        materiaali: response.meta.Kohde_Alus_rakennusmateriaali[0],
        pohjan_syvyys: response.meta.Kohde_Hylky_Osa_pohjansyvyys[0],
        minimisyvyys: response.meta.Kohde_Hylky_Osa_minimisyvyys[0],
        pituus: response.meta.Kohde_Hylky_Osa_pituus[0],
        uppoamisaika: response.meta.Kohde_Uppoaminen_aika[0],
        tyyppi: response.meta.Kohde_Alus_tyyppi[0],
      }

      if (markerRef.current) {
        markerRef.current.extra = extraInfo
      }
    }
    if (!markerRef.current.extra) {
      await fetchData()
      return true
    }
    return false
  }

  const handePopupContentUpdate = async () => {
    try {
      const isFetched = await fetchPopupExtraContent(wreck.id)
      if (isFetched && markerRef.current) {
        markerRef.current.bindPopup(getPopupContent(markerRef.current.extra))
      }
    } catch (error) {
      console.error('Error opening popup: ', error)
    }
  }

  return (
    <Marker
      ref={markerRef}
      position={[Number(wreck.meta.gpsLatitude[0]), Number(wreck.meta.gpsLongitude[0])]}
      title={he.decode(wreck.title.rendered)}
      key={wreck.id}
      icon={
        new L.Icon({
          iconUrl: wreck.marker,
          iconSize: [52, 52],
          iconAnchor: [26, 52],
          popupAnchor: [0, -52],
        })
      }
      eventHandlers={{
        popupopen: handePopupContentUpdate,
      }}
    >
      <Popup ref={popupRef} open={centerAndZoom} />
    </Marker>
  )
}
export default WreckMarker
